import React from "react";
import { Table } from "antd";
import { isEmpty } from "lodash";

const DEFAULT_PAGINATION_POSITION = ["bottomLeft"];
const DEFAULT_PAGINATION_SIZE = "small";

const CustomTable = props => {
  const {
    columns,
    data,
    rowKey,
    rowClassName,
    className,
    tableSize,
    onRow,
    loading,
    pagination,
    expandedRowRender,
    rowSelection,
    scroll,
    onChange,
    bordered,
    getPopupContainer,
    expandable,
    locale,
    sortedInfo,
    tableLayout,
    summary,
    showHeader = true,
    // Default off — AntD's built-in "click to sort ascending/descending"
    // hover tooltip on sortable column headers adds visual noise without
    // teaching the user anything new. Callers can opt in by passing `true`.
    showSorterTooltip = false,
  } = props;

  // If we have expandable config, don't use the expandedRowRender prop
  const tableExpandableProps = expandable
    ? {
        expandable,
      }
    : {
        expandedRowRender,
      };

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={rowKey}
      rowClassName={rowClassName}
      className={`antd-table-x-scroll${className ? ` ${className}` : ""}`}
      size={tableSize}
      onRow={onRow}
      loading={loading}
      pagination={
        pagination === false
          ? false
          : {
              position: DEFAULT_PAGINATION_POSITION,
              size: DEFAULT_PAGINATION_SIZE,
              ...(!isEmpty(pagination) && !!pagination ? pagination : {}),
            }
      }
      rowSelection={rowSelection}
      scroll={scroll}
      onChange={onChange}
      bordered={bordered}
      getPopupContainer={getPopupContainer}
      locale={locale}
      sortedInfo={sortedInfo}
      tableLayout={tableLayout}
      summary={summary}
      showHeader={showHeader}
      showSorterTooltip={showSorterTooltip}
      {...tableExpandableProps}
    />
  );
};

CustomTable.defaultProps = {
  tableSize: "small",
  onRow: () => {},
  loading: { spinning: false, tip: "" },
  expandedRowRender: false,
  onChange: () => {},
  scroll: null,
  bordered: true,
};

export default CustomTable;
